import React, { useState, useEffect, useMemo } from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import dummyImage from "./../../../../../dummyImages/cleanig.jpg";
import Popup from "reactjs-popup";
import { MdOutlineFileUpload } from "react-icons/md";
import './serviceImage.css';
import { Container, Spinner } from "react-bootstrap";
import AppConstants from "../../../../../AppConstants";
import { baseUrl } from "../../../../../../network/constants/constants";
import config, { getConfig } from "../../../../../../network/auth";
import axios from "../../../../../../network/api";

export const ServiceImage = ({ serviceList,service_id }) => {
  const [loading, setLoading] = useState(false);
  const [imageList, setImageList] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);



  const config = useMemo(() => {
    return getConfig()
  },[])


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      const preview = URL.createObjectURL(file);
      setPreviewUrl(preview);
    }
  };

  const handleUpload = () => {
    if (!selectedFile) return;
  

    const formData = new FormData();
    formData.append('service_images', selectedFile);
    formData.append('service', service_id, )

    setLoading(true);
    axios.post(baseUrl + `app/gallery/create/`, formData, {
      headers: {
        "Authorization": config.headers.Authorization,
      },
    })
      .then((response) => {
        fetchGallery(); 
      })
      .catch((error) => {
        console.error("Upload Error:", error);
      })
      .finally(() => {
        setLoading(false);
        setSelectedFile(null);
        setPreviewUrl(null);
      });
  };

  const fetchGallery = () => {
  
    setLoading(true);
    axios
      .get(baseUrl + `app/gallery-list-by-service/${service_id}/`, config)
      .then((response) => {
        setImageList(response.data);
      })
      .catch((error) => {
        console.error("Gallery Error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const deleteImage = (imageId) => {
    setLoading(true);
    axios.delete(baseUrl + `app/gallery/delete/${imageId}/`, config)
      .then(() => {
        fetchGallery();
      })
      .catch((error) => {
        console.error("Delete Error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchGallery();
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, []);

  return (
    <Container className="service-data-container mb-3">
      <div className="service-img">
        {loading ? (
          <div className="loader-container">
            <Spinner className='spinner-loader' />
          </div>
        ) : (
          <ResponsiveMasonry
            columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}
          >
            <Masonry gutter="20px">
            {imageList.length === 0 ? (
              <div className="no-images-message">No images are available</div>
            ) : (
              imageList.map((image) => (
                <div className="service-img-div" key={image.id}>
                  <Popup
                    className="popup-container"
                    contentStyle={{
                      borderRadius: "20px",
                      backgroundColor: "white",
                    }}
                    trigger={
                      <span className="material-icons delete-icon">
                        delete_forever
                      </span>
                    }
                    modal
                    nested
                  >
                    {(close) => (
                      <div className="delete-img-div">
                        <h3 className="delete-img-heading">Are you sure?</h3>
                        <p className="delete-img-p">
                          Do you really want to delete?
                        </p>
                        <div className="delete-btn-div">
                          <button
                            onClick={() => {
                              deleteImage(image.id);
                              close();
                            }}
                          >
                            Delete
                          </button>
                          <button onClick={close}>Cancel</button>
                        </div>
                      </div>
                    )}
                  </Popup>
                  <img
                     src={`${baseUrl}${image.service_images}`}
                    style={{
                      width: "100%",
                      display: "block",
                      cursor: "pointer",
                    }}
                    alt="Service"
                  />
                </div>
            )))}
            </Masonry>
          </ResponsiveMasonry>
        )}

        <Popup
          className="add-popup-container"
          contentStyle={{ borderRadius: "20px" }}
          trigger={
            <button className="btn-add-service-image">
              + Add Service Image
            </button>
          }
          modal
          nested
        >
          {(close) => (
            <div className="add-img-div">
              <form
                method="post"
                onSubmit={(e) => {
                  e.preventDefault();
                  handleUpload();
                  close();
                }}
              >
                <h3 className="add-img-heading">Add Service images</h3>
                <label className="add-file-upload">
                  <input
                    className="add-img-file"
                    id="file"
                    type="file"
                    onChange={handleFileChange}
                  />
                  <MdOutlineFileUpload className="upload-icon" />
                </label>

                {previewUrl && (
                  <div className="image-preview-container">
                    <img
                      src={previewUrl}
                      alt="Preview"
                      className="preview-image"
                    />
                  </div>
                )}

                <div className="submit-banner-file-container">
                  <button type="submit">Upload</button>
                  <button type="button" onClick={close}>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          )}
        </Popup>
      </div>
    </Container>
  );
};
